export default __webpack_public_path__ + "static/media/Setup-your-company-in-uae.777d5c20.png";